import { useToast } from '@frontend/ui-library';
import { ReactNode, useLayoutEffect, useRef } from 'react';

interface PageToastResetProps {
  children: ReactNode;
  pageKey?: string | null;
}

export default function PageToastReset({
  children,
  pageKey,
}: PageToastResetProps) {
  const { close } = useToast();
  const previousPageKey = useRef<string | null>(null);

  useLayoutEffect(() => {
    if (!pageKey) return;

    if (previousPageKey.current && previousPageKey.current !== pageKey) {
      close();
    }

    previousPageKey.current = pageKey;
  }, [close, pageKey]);

  return children;
}
